<template>
  <div id="contenedor-opciones-tool-bar">
    <v-tabs>
      <v-tab
        v-for="(opcion, index) in opciones"
        :key="index"
        :to="{ name: opcion.ruta }"
        exact>
        {{ opcion.nombre }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'OpcionesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'contratoEjecucionGenerales',
          icono: '',
        },
        {
          nombre: 'Reportes',
          ruta: 'contratoEjecucionReportes',
          icono: '',
        },
        {
          nombre: 'Album Fotográfico',
          ruta: 'contratoAlbum',
          icono: '',
        },
        {
          nombre: 'Videos',
          ruta: 'contratoVideos',
          icon: '',
        },
        {
          nombre: 'Anticipos',
          ruta: 'contratoEjecucionAnticipos',
          icono: '',
        },
        {
          nombre: 'Catálogo',
          ruta: 'contratoEjecucionCatalogo',
          icono: '',
        },
        {
          nombre: 'Programa',
          ruta: 'contratoEjecucionPrograma',
          icono: '',
        },
        {
          nombre: 'Estimaciones',
          ruta: 'contratoEjecucionEstimaciones',
          icono: '',
        },
        {
          nombre: 'Gráfica',
          ruta: 'contratoGraficaComparativaAvances',
          icono: '',
        },
        {
          nombre: 'Actividades',
          ruta: 'contratoEjecucionActividades',
          icono: '',
        },
        {
          nombre: 'Fechas',
          ruta: 'contratoFechas',
          icon: '',
        },
        {
          nombre: 'Garantías',
          ruta: 'contratoGarantias',
          icon: '',
        },
        {
          nombre: 'Expediente',
          ruta: 'contratoEjecucionExpediente',
          icono: '',
        },
        {
          nombre: 'Obs',
          ruta: 'contratoObservaciones',
          icono: '',
        },
        {
          nombre: 'Archivos Externos',
          ruta: 'contratoEjecucionArchivosContratista',
          icono: '',
        },
        {
          nombre: 'Diario de Actividades',
          ruta: 'contratoEjecucionDiarioActividades',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
